import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <>
      <div className="footer__container">
        <div className="top__footer">
          <p>Home</p>
          <p>Services</p>
        </div>
        <div className="footer__main">
          <div>
            <ul>
              <li></li>
              <li></li>
              <li></li>
              <li>Netflix Bangladesh</li>
            </ul>
          </div>
          <div>
            <ul>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <div>
            <ul>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
          <div>
            <ul>
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
